import { useCallback } from "react";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "@material-ui/core";

import CustomButton from "../../uiKit/Button/CustomButton";
import { useStylesDialog } from "../../uiKit/CustomDialog/customDialog";
import Checkout from "../Checkout/checkout";
import CheckoutOurBalance from "../Checkout/ourBalanceCheckout";
import DonationForm from "../Checkout/donationForm";
import OurBalanceThankYou from "./thankYou";

import { setCommunityThankOpen, setDonationFormOpen, setStripeOpen } from "../../redux/state/donationSlice";
import { getCommunityDonations } from "../../redux/state/paymentSlice";
import { getCommunity } from "../../redux/state/communitySlice";

const DonationAmountOurBalance = () => {

    const dispatch = useDispatch();
    const dialogClasses = useStylesDialog();
    const { communityId } = useParams();

    const open = useSelector(state => state.donation.donationFormOpen)
    const openStripe = useSelector(state => state.donation.stripeOpen)
    const communityThankOpen = useSelector(state => state.donation.communityThankOpen);
    const role = useSelector(state => state.community.community.role);

    const closeStripeHandler = () => dispatch(setStripeOpen(false));
    const closeFormHandler = () => dispatch(setDonationFormOpen(false));
    const closeCommunityThankHandler = useCallback(() => {
        setTimeout(() => {
            if (!communityId) return;
            const isAdmin = !!role;
            dispatch(getCommunity(communityId))
            dispatch(getCommunityDonations({
                isAdmin,
                communityId,
                page: 1,
                pageSize: 8,
            }))

        }, 2000);
        dispatch(setCommunityThankOpen(false))
    }, [dispatch, communityId, role])

    const donateHandler = useCallback(() => {
        ReactGA.event('donate_to_our_balance_start')
        dispatch(setDonationFormOpen(true))
    }, [dispatch])

    return (
        <>
            <CustomButton
                title='Donate to Our Balance'
                classNames='maxContentButton'
                onClick={donateHandler}
            />
            <Dialog
                open={open}
                onClose={closeFormHandler}
                disableScrollLock={true}
                classes={dialogClasses}
            >
                <DonationForm hasRecurring={true} />
            </Dialog >
            <Dialog
                open={openStripe}
                onClose={closeStripeHandler}
                disableScrollLock={true}
                classes={dialogClasses}
            >
                <Checkout Component={CheckoutOurBalance} type={1} />
            </Dialog>
            <Dialog
                open={communityThankOpen}
                onClose={closeCommunityThankHandler}
                disableScrollLock={true}
                classes={dialogClasses}
            >
                <OurBalanceThankYou onClose={closeCommunityThankHandler} />
            </Dialog>
        </>
    )
}

export default DonationAmountOurBalance;